export default "__VITE_ASSET__QY$PDdpm__"